export default {
  UPDATE_ACTIVE_TAB: 'UPDATE_ACTIVE_TAB',
  RESET_MAILCHIMP_PAGE: 'RESET_MAILCHIMP_PAGE'
}
